module.exports = __webpack_public_path__ + "img/dox-half.ac23fc45.gif";